import React, { useContext, useEffect, useState } from "react";

import TransitionType from "./TransitionType";
import isTouchDevice from "../SE-Component/Tooltip";
import embLabels from "../../config/emb-labels-en.json";
import { InformationPageContext } from "../CustomHooks/ContextApi";
import Tooltip from "../../utils/Tooltip";
import MyErrorBoundary from "../../utils/ErrorBoundary";
import { getProject, getProjectTypeValue } from "../../utils/project";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";
import { NMGAAS_ETO, NMGAAS_ETO_EMOL } from "../../utils/application.constants";
import CheckboxWithTooltip from "../../components/component/CheckboxWithTooltip";
import { renderEMSCapabilities, renderPMSFeatures } from "./useCasesUtility";
import AnchorResource from "./AnchorResource";

const SelectUseCase = () => {
  const [organizationValue, setOrganizationValue] = useState("");
  const {
    projectType,
    siteType,
    informationToolTIP,
    disabledFeatures,
    optimizationEngine,
    otherOptimizationStrategy,
    gridSettings,
    handleOptimizationChange,
    handleOtherOptimizationChange,
    handleOnGridFeatureChange,
    handleModeChange,
    handleOffgridModeChange,
    architectureType,
    organization,
    handleOrganizationChange,
    handleOnGridFeatureChangeGSX,
    selectedOrganization,
    useCaseHMIData,
    projectChangeHandler,
    additionalDataStorage,
    additionalUsersQty,
    invitedUserCount,
    projectTypeValue,
    handleAtsChange
  } = useContext(InformationPageContext);
  const [useCases, setUseCases] = useState({});
  const handleOrganizationValueChange = (event) => {
    const {
      target: { value },
    } = event;
    setOrganizationValue(value);
    handleOrganizationChange(event);
  };
  useEffect(() => {
    if (useCaseHMIData && Object.keys(useCaseHMIData)?.length) {
      setUseCases({ ...useCaseHMIData });
    }
  }, [useCaseHMIData]);
  useEffect(() => {
    setOrganizationValue(selectedOrganization?.organizationKey);
  }, [selectedOrganization]);
  const isOnGridFeaturesEnabled = () => {
    const status =
      optimizationEngine === "EMA" &&
        gridSettings?.remoteMonitoringControl &&
        siteType !== embLabels.PV_HYBRIDIZATION
        ? "enabled"
        : "disabled";

    return status === "enabled" ? true : false;
  };
  const isEnableGensetMainNoBess = (projectType === embLabels.GREENSTRUXURE_MICROGRID &&
    siteType === embLabels.ISLANDABLE_GSX &&
    architectureType ===
    embLabels.PV_GENSET_ATS) ||
    (embLabels.STANDARD_MICROGRID &&
      siteType === embLabels.ISLANDABLE)
    ? { cursor: "not-allowed" }
    : { cursor: "pointer" }

  const optimizationFeatures = useCases?.useCases?.["Optimization Features"] || [];
  const hasOptimizationFeature = (featureName) => optimizationFeatures.includes(featureName);
  const optimizationFeatureConfig = [
    {
      featureName: "Time of Use (Electricity Tariff based Optimization)",
      name: "tariffManagement",
      id: "customControlValidation2",
      helpId: "tou_tariffManagement",
      label:
        projectTypeValue === NMGAAS_ETO || projectTypeValue === NMGAAS_ETO_EMOL
          ? "Tariff Management - Time of Use"
          : "Time of Use (Electricity Tariff based Optimization)",
      tooltipKey: "tariffManagementTooltipData",
    },
    {
      featureName: "Demand Charge Optimization",
      name: "demandCharge",
      id: "customControlValidation1",
      helpId: "demandCharge",
      label: "Demand Charge Optimization",
      tooltipKey: "demandChargeTooltipData",
    },
    {
      featureName: "Export management",
      name: "exportManagement",
      id: "exportManagement",
      helpId: "exportManagement",
      label: "Export management",
      tooltipKey: "exportManagementTooltipData",
    },
    {
      featureName: "Islanding preparation",
      name: "islandingPreparation",
      id: "islandingPreparation",
      helpId: "Islanding preparation",
      label: "Islanding preparation",
      tooltipKey: "islandingPreparationTooltipData",
    },
    {
      featureName: "Constraints based optimization",
      name: "constraintsBasedOptimization",
      id: "constraintsBasedOptimization",
      helpId: "Constraints based optimization",
      label: "Constraints based optimization",
      tooltipKey: "constraintsBasedOptimizationTooltipData",
    },
    {
      featureName: "Self Consumption",
      name: "selfConsumption",
      id: "customControlValidation3",
      helpId: "selfConsumption",
      label: "Self Consumption",
      tooltipKey: "selfConsumptionTooltipData",
      disableOnChange: true,
    },
    {
      featureName: "Limit Energy Import/Export",
      name: "exportOptimization",
      id: "customControlValidation4",
      helpId: "exportOptimization",
      label: `${ projectTypeValue === "MGaaS ANSI"?"Limit Energy Import/Export":"Export Management"}`,
      tooltipKey: "exportOptimizationTooltipData",
    },
    {
      featureName: "Outage mode preparation",
      name: "stormPreparedness",
      id: "stormPreparedness1",
      label: "Outage mode preparation",
      tooltipKey: "stormPreparednessTooltipData",
    },
    {
      featureName: "Green Consumption",
      name: "greenConsumption",
      id: "greenConsumption1",
      helpId: "greenConsumption",
      label: "Green Consumption",
      tooltipKey: "greenConsumptionTooltipData",
    },
  ];

  return (
    <MyErrorBoundary>
      <div className="row mt-2">
        {[embLabels.GRID_CONNECTED, embLabels.ISLANDABLE, embLabels.OFF_GRID].includes(siteType) &&
          projectTypeValue === "MGaaS ANSI" && (
            <div className="col-md-12 my-2">
              <span className="labelCircle mr-2 ">{siteType === embLabels.OFF_GRID ? 4 : 3}</span>{" "}
              <span>Optimization Engine</span>
              <Tooltip
                position="right"
                iconColor="secondary"
                information="Select your Optimization Engine"
              />
            </div>
          )}
        <div className="col-md-12">
          <div className="col-md-12 border-radius-5px ">
            <div className="row">
              {[
                embLabels.ISLANDABLE,
                embLabels.GRID_CONNECTED,
                embLabels.PV_HYBRIDIZATION,
                embLabels.ISLANDABLE_GSX,
                embLabels.OFF_GRID
              ].includes(siteType) && (
                  <div
                    className={
                     ( projectTypeValue === "NMGaaS ETO" && (siteType === embLabels.ISLANDABLE|| gridSettings.isIslandable  || gridSettings.isOffGridSite))?"col-sm-4 col-md-4 col-lg-4 col-xl-4 ":
                      siteType === embLabels.ISLANDABLE || siteType === embLabels.OFF_GRID
                        ? disabledFeatures.disableCloud
                          ? "col-sm-4 col-md-4 col-lg-4 col-xl-4 se-block-disabled"
                          : (siteType === embLabels.OFF_GRID && !gridSettings.remoteMonitoringControl) ? "d-none" : "col-sm-4 col-md-4 col-lg-4 col-xl-4"
                        : "col-md-4 "
                    }
                  >

                    {[
                      embLabels.ISLANDABLE,
                      embLabels.GRID_CONNECTED,
                      embLabels.ISLANDABLE_GSX,
                    ].includes(siteType) &&
                      gridSettings?.remoteMonitoringControl && (projectTypeValue !== "NMGaaS ETO") && (
                        <div className="row">
                          <div className="col-md-12 mt-1">
                            <span>Optimization Engine</span>
                          </div>
                        </div>
                      )}
                    {([
                      embLabels.ISLANDABLE,
                      embLabels.GRID_CONNECTED,
                       embLabels.OFF_GRID
                    ].includes(siteType) ||(projectTypeValue === "NMGaaS ETO"&&( gridSettings.isIslandable ||  gridSettings.isOffGridSite))) &&
                      (gridSettings?.remoteMonitoringControl || siteType === embLabels.OFF_GRID)&& (projectTypeValue === "NMGaaS ETO") && (
                        <>
                          <div className="row">
                            <div className="col-md-12 mt-2 bold">
                              <span>EMS capabilities</span>
                            </div>
                          </div>
                          <div className="row ">
                            {renderEMSCapabilities({ siteType, gridSettings, informationToolTIP, handleOnGridFeatureChange, useCases })}
                           
                          </div>
                         { gridSettings?.remoteMonitoringControl === true && <div className="row mt-2">
                              {useCases?.useCases?.["Ems capabilities"]?.includes("Data Storage(Years)") && (
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-0">
                                  <div className="form-group row mb-0">
                                    <label
                                      htmlFor="additionalDataStorage"
                                      className="col-sm-6 col-form-label d-flex align-items-center"
                                    >
                                      {`Data Storage(Years)`}  <span>
                                      <Tooltip
                                        position="right"
                                        iconColor="secondary"
                                        iconSize="small"
                                        information={informationToolTIP?.additionalDataStorageTooltip}
                                      />
                                    </span>
                                    </label>
                                  

                                    <div className="col-sm-4">
                                      <select
                                        data-help-id="additionalDataStorage"
                                        id="additionalDataStorage"
                                        className="col-sm-12 col-lg-12 col-md-12 col-xl-12 p-0 form-control form-control-sm text-center"
                                        name="additionalDataStorage"
                                        value={additionalDataStorage}
                                        onChange={projectChangeHandler}
                                      >
                                        {useCases?.useCases?.["Data Storage(Years)"]?.map((data) => (
                                          <option key={data} value={data}>
                                            {data}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {useCases?.useCases?.["Ems capabilities"]?.includes("Users") && (
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-0">
                                  <div className="form-group row ">
                                    <label
                                      htmlFor="additionalUsersQty"
                                      className="col-sm-6 col-form-label  d-flex align-items-center justify-content-center pl-5 pr-0"
                                    >
                                      {`Users`} <span>
                                      <Tooltip
                                        position="right"
                                        iconColor="secondary"
                                        iconSize="small"
                                        information={informationToolTIP?.additionalUsersQtyTooltip}
                                      />
                                    </span>
                                    </label>
                                   

                                    <div className="col-sm-4">
                                      <select
                                        className="col-sm-12 col-lg-12 col-md-12 col-xl-12 p-0 form-control form-control-sm text-center"
                                        name="additionalUsersQty"
                                        data-help-id="additionalUsersQty"
                                        id="additionalUsersQty"
                                        value={additionalUsersQty}
                                        onChange={projectChangeHandler}
                                      >
                                        {useCases?.useCases?.["Users"]?.map((data) => (
                                          <option key={"users_" + data} value={data} className={Number(data) < invitedUserCount ? "der-disabled" : ""}>
                                            {data}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>}
                        </>
                      )}
                    {[
                      embLabels.ISLANDABLE,
                      embLabels.GRID_CONNECTED,
                      embLabels.OFF_GRID,
                      embLabels.ISLANDABLE_GSX,
                    ].includes(siteType) &&
                      gridSettings?.remoteMonitoringControl && (
                        <div className="row">
                          <div className="col-md-12">
                            {!["DaaS ANSI", "DaaS IEC", "DaaS ETO", "NMGaaS ETO"].includes(
                              projectTypeValue
                            ) && (
                                <div className="row">

                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        data-help-id="emaOptimization"
                                        className="custom-control-input islandableRadio asCompatible"
                                        name="optimizationEngine"
                                        id="emaOptimization"
                                        value="EMA"
                                        checked={optimizationEngine === "EMA"}
                                        onChange={handleOptimizationChange}
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="emaOptimization"
                                      >
                                        Microgrid Advisor
                                      </label>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-0">
                                    <div className="form-group row d-flex align-items-center text-right">
                                      <label
                                        htmlFor="additionalDataStorage"
                                        className="col-sm-5 p-0 pl-1 col-form-label"
                                      >
                                        {`Data Storage(Years)`}
                                      </label>
                                      <span className="col-sm-1">
                                        <Tooltip
                                          position="right"
                                          iconColor="secondary"
                                          iconSize="small"
                                          information={
                                            informationToolTIP?.additionalDataStorageTooltip
                                          }
                                        />
                                      </span>

                                      <div className="col-sm-3">
                                        <select
                                          data-help-id="additionalDataStorage"
                                          id="additionalDataStorage"
                                          className="col-sm-12 col-lg-12 col-md-12 col-xl-12 p-0 form-control form-control-sm"
                                          name="additionalDataStorage"
                                          value={additionalDataStorage}
                                          onChange={projectChangeHandler}
                                        >
                                          {useCases?.useCases?.[
                                            "Data Storage(Years)"
                                          ]?.map((data) => (
                                            <option key={data} value={data}>
                                              {data}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-0">
                                    <div className="form-group row d-flex align-items-center text-right">
                                      <label
                                        htmlFor="additionalUsersQty"
                                        className="col-sm-5 p-0 pl-1 col-form-label"
                                      >
                                        {`Users`}
                                      </label>
                                      <span className="col-sm-1">
                                        <Tooltip
                                          position="right"
                                          iconColor="secondary"
                                          iconSize="small"
                                          information={
                                            informationToolTIP?.additionalUsersQtyTooltip
                                          }
                                        />
                                      </span>

                                      <div className="col-sm-3">
                                        <select
                                          className="col-sm-12 col-lg-12 col-md-12 col-xl-12 p-0 form-control form-control-sm"
                                          name="additionalUsersQty"
                                          data-help-id="additionalUsersQty"
                                          id="additionalUsersQty"
                                          value={additionalUsersQty}
                                          onChange={projectChangeHandler}
                                        >
                                          {useCases?.useCases?.[
                                            "Users"
                                          ]?.map((data) => (
                                            <option key={"users_" + data} value={data} className={Number(data) < invitedUserCount ? "der-disabled" : ""}>
                                              {data}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              )}
                            {projectTypeValue !== "MGaaS IEC" &&
                              projectTypeValue !== "MGaaS ETO" &&
                              projectTypeValue !== NMGAAS_ETO &&
                              projectTypeValue !== NMGAAS_ETO_EMOL &&
                              !(
                                siteType === "GRID_CONNECTED" ||
                                siteType === "ISLANDABLE" ||
                                siteType === "OFF_GRID"
                              ) && (
                                <div className="row">
                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1 ">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        className="custom-control-input islandableRadio asCompatible"
                                        name="optimizationEngine"
                                        id="otherOptimization"
                                        value="OTHER"
                                        checked={optimizationEngine === "OTHER"}
                                        onChange={handleOptimizationChange}
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="otherOptimization"
                                      >
                                        Other optimization
                                      </label>
                                    </div>
                                  </div>
                                  {optimizationEngine === "OTHER" && (
                                    <div className="row">
                                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ml-5 mt-1  mb-2 ">
                                        <div className="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            className="custom-control-input islandableRadio asCompatible"
                                            name="otherOptimizationStrategy"
                                            id="autogridOptimization"
                                            value="AUTOGRID"
                                            checked={
                                              otherOptimizationStrategy ===
                                              "AUTOGRID"
                                            }
                                            onChange={
                                              handleOtherOptimizationChange
                                            }
                                          />
                                          <label
                                            className="custom-control-label line-height-25"
                                            htmlFor="autogridOptimization"
                                          >
                                            Autogrid Flex &trade;
                                          </label>
                                          <Tooltip
                                            position="right"
                                            iconColor="secondary"
                                            iconSize="small"
                                            information={
                                              informationToolTIP?.autogridflexTooltipData
                                            }
                                          />
                                        </div>
                                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ml-5 mt-1  mb-2 ">
                                          <div className="form-group row ">
                                            <label
                                              htmlFor="inputOrganization"
                                              className="col-sm-2 col-form-label text-right mr-4"
                                            >
                                              Organization
                                            </label>
                                            <div className="col-sm-5 ">
                                              <input
                                                type="password"
                                                name="organization"
                                                className="form-control form-control-md"
                                                autoComplete="new-password"
                                                value={organizationValue}
                                                onChange={
                                                  handleOrganizationValueChange
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                          </div>
                        </div>
                      )}

                    {(optimizationEngine === "EMA" ||
                      (optimizationEngine === "OTHER" &&
                        siteType === embLabels.GRID_CONNECTED) ||
                      siteType === embLabels.ISLANDABLE) && siteType !== embLabels.OFF_GRID && projectTypeValue !== NMGAAS_ETO && (
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-1">
                            <span>Optimization Features </span>
                          </div>
                        </div>
                      )}
                    { (
                      <>
                        {optimizationFeatureConfig.map((feature) => (
                          hasOptimizationFeature(feature?.featureName) && (
                            <div className="row" key={feature?.name}>
                              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input asCompatible"
                                    data-help-id={feature?.helpId}
                                    name={feature?.name}
                                    id={feature?.id}
                                    value={gridSettings?.[feature?.name]}
                                    checked={gridSettings?.[feature?.name]}
                                    onChange={
                                      feature?.disableOnChange
                                        ? undefined
                                        : handleOnGridFeatureChange
                                    }
                                  />
                                  <label
                                    className="custom-control-label line-height-25"
                                    htmlFor={feature?.id}
                                  >
                                    {feature?.label}
                                  </label>
                                  <Tooltip
                                    position="right"
                                    iconColor="secondary"
                                    iconSize="small"
                                    information={informationToolTIP?.[feature?.tooltipKey]}
                                  />
                                </div>
                                {feature?.featureName === "Time of Use (Electricity Tariff based Optimization)" && projectTypeValue === "NMGaaS ETO" && false && <div className="row pl-4">
                                  <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input asCompatible"
                                        data-help-id="tou_tariffManagement_energyImport"
                                        name="importTariff"
                                        id="importTariff"
                                        value={gridSettings.importTariff}
                                        checked={gridSettings.importTariff}
                                        onChange={handleOnGridFeatureChange}
                                        disabled={!gridSettings.tariffManagement}
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="importTariff"
                                      >
                                        {"Energy Import"}
                                      </label>
                                    </div>
                                  </div>
                                  <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input asCompatible"
                                        data-help-id="tou_tariffManagement_energyExport"
                                        name="exportTariff"
                                        id="exportTariff"
                                        value={gridSettings.exportTariff}
                                        checked={gridSettings.exportTariff}
                                        onChange={handleOnGridFeatureChange}
                                        disabled={!gridSettings.tariffManagement}
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="exportTariff"
                                      >
                                        {"Energy Export"}
                                      </label>
                                    </div>
                                  </div>
                                </div>}
                              </div>
                            </div>
                          )
                        ))}
                      </>
                    )}
                    {((optimizationEngine === "EMA" &&
                      siteType != "PV_HYBRIDIZATION") ||
                      (optimizationEngine === "OTHER" &&
                        siteType === embLabels.GRID_CONNECTED) ||
                      siteType === embLabels.ISLANDABLE) &&
                      (![NMGAAS_ETO, NMGAAS_ETO_EMOL].includes(getProject()?.projectTypeValue)) && siteType !== embLabels.OFF_GRID &&
                      (
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-1">
                            <span>Flexibility Services </span>
                          </div>
                        </div>
                      )}
                    {
                      useCases?.useCases?.["Flexibility Services"]?.includes(
                        "Manual Demand Response"
                      ) && (
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                data-help-id="manualDemandResponse"
                                name="manualDemandResponse"
                                id="customControlValidation41"
                                value={gridSettings?.manualDemandResponse}
                                checked={gridSettings?.manualDemandResponse}
                                onChange={handleOnGridFeatureChange}
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="customControlValidation41"
                              >
                                Manual Demand Response
                              </label>
                              <Tooltip
                                position="right"
                                iconColor="secondary"
                                iconSize="small"
                                information={
                                  informationToolTIP?.manualDemandResponseTooltipData
                                }
                              />
                            </div>
                          </div>
                        </div>
                      )}


                    {isOnGridFeaturesEnabled() &&
                      useCases?.useCases?.["Flexibility Services"]?.includes(
                        "Electrical Vehicle Energy Management"
                      ) && (
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                data-help-id="electricalVehicleEnergyManagement"
                                name="electricalVehicleEnergyManagement"
                                id="electricalVehicleEnergyManagement"
                                value={gridSettings?.electricalVehicleEnergyManagement}
                                checked={gridSettings?.electricalVehicleEnergyManagement}
                                onChange={handleOnGridFeatureChange}
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="electricalVehicleEnergyManagement"
                              >
                                Electrical Vehicle Energy Management
                              </label>
                              <Tooltip
                                position="right"
                                iconColor="secondary"
                                iconSize="small"
                                information={
                                  informationToolTIP?.electricalVehicleEnergyManagement
                                }
                              />
                            </div>
                          </div>
                        </div>
                      )}



                    {[embLabels.STANDARD_MICROGRID].includes(projectType) &&
                      getProject()?.projectTypeValue !== "MGaaS ETO" &&
                      getProject()?.projectTypeValue !== NMGAAS_ETO &&
                      getProject()?.projectTypeValue !== NMGAAS_ETO_EMOL &&
                      getProject()?.projectTypeValue !== "MGaaS IEC" &&
                      [
                        embLabels.ISLANDABLE,
                        embLabels.GRID_CONNECTED,
                        embLabels.ISLANDABLE_GSX,
                      ].includes(siteType) && (
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                data-help-id="specificMonitoring"
                                name="specificMonitoring"
                                id="specificMonitoring"
                                value={gridSettings?.specificMonitoring}
                                checked={gridSettings?.specificMonitoring}
                                onChange={handleOnGridFeatureChangeGSX}
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="specificMonitoring"
                              >
                                Specific Monitoring
                              </label>
                              <Tooltip
                                position="right"
                                iconColor="secondary"
                                iconSize="small"
                                information={
                                  informationToolTIP?.specificMonitoringTooltipData
                                }
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    {false &&
                      useCases?.useCases?.["Flexibility Services"]?.includes(
                        "Net Metering"
                      ) &&
                      false && (
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                name="netMetering"
                                id="netMetering1"
                                value={gridSettings?.netMetering}
                                checked={gridSettings?.netMetering}
                                onChange={handleOnGridFeatureChange}
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="netMetering1"
                              >
                                Net Metering
                              </label>
                              <Tooltip
                                position="right"
                                iconColor="secondary"
                                iconSize="small"
                                information={
                                  informationToolTIP?.netMeteringTooltipData
                                }
                              />
                            </div>
                          </div>
                        </div>
                      )}

                    {useCases?.useCases?.["Resilience"]?.includes(
                      "off Grid Mode"
                    ) &&
                      (optimizationEngine === "EMA" ||
                        (optimizationEngine === "OTHER" &&
                          siteType === embLabels.GRID_CONNECTED) ||
                        siteType === embLabels.ISLANDABLE) && (
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-1">
                            <span>Resilience </span>
                          </div>
                        </div>
                      )}
                    {useCases?.useCases?.["Resilience"]?.includes(
                      "off Grid Mode"
                    ) &&
                      isOnGridFeaturesEnabled() && (
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input asCompatible"
                                data-help-id="offGridMode"
                                name="offGridMode"
                                id="offGridMode1"
                                value={gridSettings?.offGridMode}
                                checked={gridSettings?.offGridMode}
                                onChange={handleOnGridFeatureChange}
                              />
                              <label
                                className="custom-control-label line-height-25"
                                htmlFor="offGridMode1"
                              >
                                Prepare for OffGrid Mode
                              </label>
                              <Tooltip
                                position="right"
                                iconColor="secondary"
                                iconSize="small"
                                information={
                                  informationToolTIP?.offGridModeTooltipData
                                }
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    {(useCases?.useCases?.["Real Time Control"]?.length > 0 && optimizationEngine === "EMA" ||
                      (optimizationEngine === "OTHER" &&
                        siteType === embLabels.ISLANDABLE_GSX &&
                        architectureType === embLabels.PV_GENSET_ATS)) && siteType !== embLabels.OFF_GRID && (
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-1">
                            <span>Real Time Control </span>
                          </div>
                        </div>
                      )}
                    {(optimizationEngine === "EMA" ||
                      (optimizationEngine === "OTHER" &&
                        siteType === embLabels.ISLANDABLE_GSX &&
                        architectureType === embLabels.PV_GENSET_ATS)) && (
                        <>
                          {false && (
                            <div className="row">
                              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input asCompatible"
                                    name="noImport"
                                    id="customControlValidation51"
                                    value={gridSettings?.noImport}
                                    checked={gridSettings?.noImport}
                                    onChange={handleOnGridFeatureChange}
                                  />
                                  <label
                                    className="custom-control-label line-height-25"
                                    htmlFor="customControlValidation51"
                                  >
                                    Real Time Import Control (EMA Controller based)
                                  </label>
                                  <Tooltip
                                    position="right"
                                    iconColor="secondary"
                                    iconSize="small"
                                    information={
                                      informationToolTIP?.realTimeImportControlEMATooltipData
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                          {useCases?.useCases?.["Real Time Control"]?.includes(
                            "Real Time Export Control (EMO Controller based)"
                          ) && (
                              <>
                                <div className="row">
                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input asCompatible"
                                        data-help-id="noExport"
                                        name="noExport"
                                        id="customControlValidation52"
                                        value={gridSettings?.noExport}
                                        checked={gridSettings?.noExport}
                                        onChange={handleOnGridFeatureChange}
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="customControlValidation52"
                                      >
                                        Real Time Export Control (EMO Controller
                                        based)
                                      </label>
                                      <Tooltip
                                        position="right"
                                        iconColor="secondary"
                                        iconSize="small"
                                        information={
                                          ["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(
                                            projectTypeValue
                                          )
                                            ? informationToolTIP?.realTimeExportControlANSI
                                            : informationToolTIP?.realTimeExportControlEMOTooltipData
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                                {gridSettings?.noExport && <div className="row pl-4">
                                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2">
                                    <div className="custom-control custom-radio">
                                      <input
                                        type="radio"
                                        className="custom-control-input islandableRadio asCompatible"
                                        data-help-id="spanishCodeRealTime"
                                        name="spanishCodeRealTime"
                                        id="emaOptimization2"
                                        value={false}
                                        checked={gridSettings?.spanishCodeRealTime === false}
                                        onChange={handleOnGridFeatureChange}
                                      />
                                      <label
                                        className="custom-control-label line-height-25"
                                        htmlFor="emaOptimization2"
                                      >
                                        Standard real time export control
                                      </label>
                                      <Tooltip
                                        position="right"
                                        iconColor="secondary"
                                        iconSize="small"
                                        information={informationToolTIP?.standard}
                                      />
                                    </div>
                                  </div>
                                  {(projectTypeValue === "MGaaS IEC" ||
                                    projectTypeValue === "MGaaS ETO" || projectTypeValue === NMGAAS_ETO || projectTypeValue === NMGAAS_ETO_EMOL) &&
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2">
                                      <div className="custom-control custom-radio">
                                        <input
                                          type="radio"
                                          className="custom-control-input islandableRadio asCompatible der-disabled"
                                          data-help-id="spanishCodeRealTimeRD"
                                          name="spanishCodeRealTime"
                                          id="emaOptimization1"
                                          value={true}
                                          checked={gridSettings?.spanishCodeRealTime === true}
                                          onChange={true ? undefined : handleOnGridFeatureChange}
                                          disabled={true}
                                        />
                                        <label
                                          className="custom-control-label line-height-25"
                                          htmlFor="emaOptimization1"
                                        >
                                          RD 244 2019 Spanish grid code compliant
                                        </label>
                                        <Tooltip
                                          position="right"
                                          iconColor="secondary"
                                          iconSize="small"
                                          information={informationToolTIP?.rd2442019}
                                        />
                                      </div>
                                    </div>}

                                </div>}
                              </>
                            )}
                          {useCases?.useCases?.["Real Time Control"]?.includes(
                            "Controlled BESS Energy Exchanges with the grid"
                          ) && (
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input asCompatible"
                                      name="bessEnergyExchanges"
                                      id="bessEnergyExchanges1"
                                      value={gridSettings?.bessEnergyExchanges}
                                      checked={gridSettings?.bessEnergyExchanges}
                                      onChange={handleOnGridFeatureChangeGSX}
                                    />
                                    <label
                                      className="custom-control-label line-height-25"
                                      htmlFor="bessEnergyExchanges1"
                                    >
                                      Controlled BESS Energy Exchanges with the grid
                                    </label>
                                    <Tooltip
                                      position="right"
                                      iconColor="secondary"
                                      iconSize="small"
                                      information="Allow to control Energy exchanges between the BESS and the Grid. If not selected, BESS will be allowed to charge and discharge from/to the grid (unrestricted exchanges)"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                        </>
                      )}

                    {siteType != "PV_HYBRIDIZATION" &&
                      useCases?.useCases?.["Compliance"]?.includes(
                        "antiIslandingDetection"
                      ) && (
                        <>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-1">
                              <span>Compliance </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input asCompatible"
                                  data-help-id="antiIslandingDetection"
                                  name="antiIslandingDetection"
                                  id="antiIslandingDetection"
                                  value={gridSettings?.antiIslandingDetection}
                                  checked={gridSettings?.antiIslandingDetection}
                                  onChange={handleOnGridFeatureChangeGSX}
                                />
                                <label
                                  className="custom-control-label line-height-25"
                                  htmlFor="antiIslandingDetection"
                                >
                                  Anti Islanding detection
                                </label>
                                <Tooltip
                                  position="right"
                                  iconColor="secondary"
                                  iconSize="small"
                                  information={
                                    informationToolTIP?.antiIslandingDetectionTooltipData
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                )}

              {![NMGAAS_ETO_EMOL].includes(projectTypeValue) && [
                embLabels.STANDARD_MICROGRID,
                embLabels.GREENSTRUXURE_MICROGRID,
              ].includes(projectType) &&
               ( [
                  embLabels.ISLANDABLE,
                   embLabels.ISLANDABLE_GSX,
                  embLabels.OFF_GRID,
                  embLabels.GRID_CONNECTED,
                ].includes(siteType) || (projectTypeValue === "NMGaaS ETO"&&( gridSettings.isIslandable || gridSettings.isOffGridSite))) && (
                  <div
                    className={` ${(projectTypeValue === "NMGaaS ETO" && (siteType === embLabels.ISLANDABLE|| siteType === embLabels.OFF_GRID||  gridSettings.isIslandable  ||  gridSettings.isOffGridSite ))?
                         "col-sm-4 col-md-4 col-lg-4 col-xl-4 border-left"
                        : disabledFeatures.disableOpertaions
                        ? "col-sm-3 col-md-3 col-lg-3 col-xl-3 border-left se-block-disabled"
                        : "col-sm-3 col-md-3 col-lg-3 col-xl-3 border-left"
                      }`}
                  >
                    {siteType !== embLabels.GRID_CONNECTED && <div className="row">
                      <div className="col-md-12 pr-0">
                        {projectTypeValue === NMGAAS_ETO  &&
                          <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                            <span className="bold">
                             PMS capabilities
                            </span>
                          </div>
                        </div>
                        }
                     {  siteType !== embLabels.GRID_CONNECTED && <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-1">
                            <span>
                            {projectTypeValue === NMGAAS_ETO ?"Anchor resource": "Asset Configuration"}
                              <span className="se-mandatory">*</span>{" "}
                            </span>
                          </div>
                        </div>}


                   { siteType !== embLabels.GRID_CONNECTED && ( 
                    <> 
                    <AnchorResource
                        id="customRadio4"
                        value="NO_FUEL"
                        label={projectTypeValue === NMGAAS_ETO ?"BESS only":"BESS main, No Genset"}
                        checked={gridSettings?.mode === "NO_FUEL"}
                        disabled={
                          !useCases?.useCases?.["Asset Configuration"]?.includes("NO_FUEL")
                        }
                        onChange={handleModeChange}
                        tooltipContent={informationToolTIP?.noFuelTooltipData}
                      />
                       <AnchorResource
                        id="customRadio5"
                        value="FUEL_ERASER"
                        label="BESS main, Genset as backup"
                        checked={gridSettings?.mode === "FUEL_ERASER"}
                        disabled={
                          !useCases?.useCases?.["Asset Configuration"]?.includes("FUEL_ERASER")
                        }
                        onChange={handleModeChange}
                        tooltipContent={informationToolTIP?.fuelEraserTooltipData}
                      />
                          {       projectTypeValue === NMGAAS_ETO && 
                           <AnchorResource
                        id="customRadio7"
                        value={gridSettings.atsEnable === true ?"GENSET_MAIN_NO_BESS":"FUEL_SAVER"}
                        label="Genset only"
                        checked={gridSettings?.mode === "GENSET_MAIN_NO_BESS" || gridSettings?.mode === "FUEL_SAVER"}
                        disabled={!useCases?.useCases?.["Asset Configuration"]?.includes("PV_HYBRIDIZATION")
                        }
                        onChange={handleModeChange}
                        tooltipContent={informationToolTIP?.fuelNoBessToolTipData}
                        // customStyle={isEnableGensetMainNoBess}
                      >

                     {  siteType !== embLabels.OFF_GRID && <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                          <div className="row ">
                        <div className="col-sm-9 col-md-9 col-lg-9 col-xl-9 d-flex align-items-center justify-content-start pr-0 pl-5 mb-1">
          
                          <span>{gridSettings.atsEnable === true ? "With Automatic Transfer Switch" : "Without Automatic Transfer Switch"}</span>
                            <Tooltip
                              position="right"
                              iconColor="secondary"
                              iconSize="small"
                              information={gridSettings.atsEnable === true ?informationToolTIP?.gensetPVHybridToolTipData:informationToolTIP?.fuelNoBessToolTipData}
                            />
                     
                        </div>
                        <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2 pl-0">
                          <div className="custom-control custom-switch pointer mx-3">
                            <input
                              type="checkbox"
                              className={`custom-control-input pointer asCompatible `}
                              id="atsmodeSwitch"
                              checked={gridSettings.atsEnable}
                              value={gridSettings.atsEnable === true ? "With ATS" : "Without ATS" }
                              onChange={e =>(siteType === "OFF_GRID" || gridSettings.isOffGridSite)?handleOffgridModeChange(e):handleAtsChange(e)}
                            />
                            <label
                              className="custom-control-label line-height-25 pointer"
                              htmlFor="atsmodeSwitch"
                            ></label>
                          </div>
                        </div>
                      </div>
                        </div>}
                      </AnchorResource>
                      }
                      </>)}
                     

                    { projectTypeValue !== NMGAAS_ETO &&  <AnchorResource
                        id="customRadio6"
                        value="FUEL_SAVER"
                        label="Genset main, BESS grid tied"
                        checked={gridSettings?.mode === "FUEL_SAVER"}
                        disabled={
                          !useCases?.useCases?.["Asset Configuration"]?.includes("FUEL_SAVER")
                        }
                        onChange={handleModeChange}
                        tooltipContent={informationToolTIP?.fuelSaverTooltipData}
                        useSeTooltip={false} // uses your <Tooltip /> component
                      />
}
               {       projectTypeValue !== NMGAAS_ETO && 
                       <AnchorResource
                        id="customRadio7"
                        value="GENSET_MAIN_NO_BESS"
                        label="Genset main, No BESS"
                        checked={
                          gridSettings?.mode === "GENSET_MAIN_NO_BESS"
                            ? false
                            : projectType === embLabels.GREENSTRUXURE_MICROGRID &&
                              siteType === embLabels.ISLANDABLE_GSX &&
                              architectureType === embLabels.PV_GENSET_ATS
                              ? false
                              : embLabels.STANDARD_MICROGRID &&
                                siteType === embLabels.ISLANDABLE
                                ? false
                                : embLabels.STANDARD_MICROGRID &&
                                  siteType === embLabels.OFF_GRID
                                  ? false
                                  : true
                        }
                        disabled={
                          !useCases?.useCases?.["Asset Configuration"]?.includes(
                            "GENSET_MAIN_NO_BESS"
                          )
                        }
                        onChange={handleModeChange}
                        tooltipContent={informationToolTIP?.fuelNoBessToolTipData}
                        customStyle={isEnableGensetMainNoBess}
                      />}
                      </div>
                    </div>}
                    {
                        projectTypeValue === NMGAAS_ETO && 
                        <>
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-1">
                            <span className="bold"> PMS features</span>
                          </div>
                          </div>
                          <div className="row">
                            {renderPMSFeatures({ siteType, gridSettings, informationToolTIP, handleOnGridFeatureChange, useCases, embLabels, projectTypeValue })}
                          </div>
                        </>
                    }
                  </div>
                )}
                {

                }

              {![NMGAAS_ETO_EMOL].includes(projectTypeValue) && [
                embLabels.STANDARD_MICROGRID,
                embLabels.GREENSTRUXURE_MICROGRID,
              ].includes(projectType) &&
               ( [
                  embLabels.ISLANDABLE,
                  embLabels.OFF_GRID,
                  embLabels.ISLANDABLE_GSX,
                ].includes(siteType) ||(projectTypeValue === "NMGaaS ETO"&&( gridSettings.isIslandable || gridSettings.isOffGridSite))) && <TransitionType />}

              {/* {siteType === embLabels.OFF_GRID && (
                <div className="col-sm-4 se-block-disabled mt-6">
                  <div className="blur mt-5">
                    <span>Coming Soon</span>
                  </div>
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </MyErrorBoundary>
  );
};

export default SelectUseCase;
